var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.302 4.36537C9.48298 3.54637 8.41198 3.13337 7.33398 3.13337V7.33337L4.36598 10.3014C6.00398 11.9394 8.66398 11.9394 10.309 10.3014C11.947 8.66337 11.947 6.00337 10.302 4.36537ZM7.33398 0.333374C3.46998 0.333374 0.333984 3.46937 0.333984 7.33337C0.333984 11.1974 3.46998 14.3334 7.33398 14.3334C11.198 14.3334 14.334 11.1974 14.334 7.33337C14.334 3.46937 11.198 0.333374 7.33398 0.333374ZM7.33398 12.9334C4.23998 12.9334 1.73398 10.4274 1.73398 7.33337C1.73398 4.23937 4.23998 1.73337 7.33398 1.73337C10.428 1.73337 12.934 4.23937 12.934 7.33337C12.934 10.4274 10.428 12.9334 7.33398 12.9334Z",
    fill: "#C058FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.f51787ec23da6a490166367f50cb70ee.svg";
export { ForwardRef as ReactComponent };